import React from 'react'
import GenericIcon from 'components/GenericIcon'

class FormItem extends React.Component {

  onClick = () => {
    const { option, type } = this.props;
    let key = Date.now();

    this.props.onClick({
      key: key,
      data: {
        key,
        option,
        type,
      }
    })
  }

  render() {
    const { iconName, title } = this.props;

    return(
      <div className='card card-border card-btn' onClick={ this.onClick } >
        <div>
          <div className='media mt-1 mb-1'>
            <div className='media-image mr-3 align-self-top'>
              <GenericIcon name={ iconName } />
            </div>
            <div className='media-body'>
              { title }
            </div>
            <div className='align-self-center btn-icon'>
              <div className='align-self-center btn-icon'>
                <div className='material-icons'>add_circle_outline</div>
              </div>
            </div>
          </div>
        </div>
    </div>
    )
  }
}

export default FormItem;
